const provinces = {
  ALBERTA: 'AB',
  BRITISH_COLUMBIA: 'BC',
  MANITOBA: 'MB',
  NEW_BRUNSWICK: 'NB',
  NEWFOUNDLAND_AND_LABRADOR: 'NL',
  NOVA_SCOTIA: 'NS',
  ONTARIO: 'ON',
  PRINCE_EDWARD_ISLAND: 'PE',
  QUEBEC: 'QC',
  SASKATCHEWAN: 'SK',
} as const;

const provincesArray = Object.values(provinces);

const provincesAbbreviationSet = new Set<string>(provincesArray);

const isValidProvinceAbbreviation = (province?: string | null): boolean =>
  province ? provincesAbbreviationSet.has(province) : false;

export { provinces, provincesArray, isValidProvinceAbbreviation };
